import {forwardRef} from "react";

export function fixedForwardRef<T, P = {}>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode
): (props: P & React.RefAttributes<T>) => React.ReactNode {
  // typing this is hard. Won't no longer be needed for react 19 fortunately
  return forwardRef(render as any) as any;
}
